import Vue from 'vue';
import { MutationTree } from 'vuex';
import { State } from '@/manager/client/store/state';
import { Client } from '@/manager/client/client.model';

export interface Mutations {
  setClientList: { list: Client[] };
}

export const mutations: MutationTree<State> = {
  setClientList: (state, payload) => {
    state.list = payload;
  },
  setClientPaginationInfo: (state, payload) => {
    state.clientPaginationInfo = { ...state.clientPaginationInfo, ...payload };
  },
  addClientPaginationInfoOption: (state, payload) => {
    state.clientPaginationInfo = { ...state.clientPaginationInfo, ...payload };
  },
  setGenderFilter: (state, payload) => {
    state.genderFilter = payload;
  },
  setSearchString: (state, payload) => {
    state.searchString = payload;
  },
  setLocationFilter: (state, payload) => {
    state.locationFilter = payload;
  },
  setFiscalDataFilter: (state, payload) => {
    state.fiscalDataFilter = payload;
  },
  setClientDateFilter: (state, payload) => {
    state.clientDateFilter = payload;
  },
  setProcedencyFilter: (state, payload) => {
    state.procedencyFilter = payload;
  },
  setLevelUpDataFilter: (state, payload) => {
    state.levelUpDataFilter = payload;
  },
  setCurseFilter: (state, payload) => {
    state.curseFilter = payload;
  },
  setConferenceFilter: (state, payload) => {
    state.conferenceFilter = payload;
  },
  setEventsFilter: (state, payload) => {
    state.eventsFilter = payload;
  },
  setTagsFilter: (state, payload) => {
    state.tagsFilter = payload;
  },
  newClient: (state, payload) => {
    state.list.push(payload);
  },
  updateClient: (state, payload) => {
    const index = state.list.map((item: any) => item.id).indexOf(payload.id);
    if (index > -1) {
      const participant = state.list[index];
      const newClient = Object.assign({}, participant, payload);
      Vue.set(state.list, index, newClient);
    }
  },
  deleteClient: (state, payload) => {
    const index = state.list.map((item: any) => item.id).indexOf(payload.id);
    if (index > -1) {
      state.list.splice(index, 1);
    }
  },
  setAcquiredCoursesList: (state, payload) => {
    state.acquiredCoursesList = payload;
  },
  setProcedencyList: (state, payload) => {
    state.procedencyList = payload;
  },
  setTagList: (state, payload) => {
    state.tagsList = payload;
  },
  setCountryList: (state, payload) => {
    state.countryList = payload;
  },
  setProvinceList: (state, payload) => {
    state.provinceList = payload;
  },
  setSearchFiscalDataExtension: (state, payload) => {
    state.searchFiscalDataExtension = payload;
  },
};
